export const TOKENS = {
  light: {
    white: '#FFFFFF',
    black: '#000000',

    contrast_0: '#FFFFFF',
    contrast_25: '#F9F7FB',
    contrast_50: '#F3EEF8',
    contrast_100: '#E7DDF1',
    contrast_200: '#D4C3E6',
    contrast_300: '#BFA8DA',
    contrast_400: '#A88CCE',
    contrast_500: '#8E6EC0',
    contrast_600: '#7558A3',
    contrast_700: '#28004E',
    contrast_800: '#28004E',
    contrast_900: '#28004E',
    contrast_950: '#28004E',
    contrast_975: '#28004E',
    contrast_1000: '#28004E',

    primary_25: '#F5F9FF',
    primary_50: '#E5F0FF',
    primary_100: '#CCE1FF',
    primary_200: '#A8CCFF',
    primary_300: '#75AFFF',
    primary_400: '#4291FF',
    primary_500: '#006AFF',
    primary_600: '#0059D6',
    primary_700: '#0048AD',
    primary_800: '#00398A',
    primary_900: '#002861',
    primary_950: '#001E47',
    primary_975: '#001533',

    negative_25: '#FFF5F7',
    negative_50: '#FEE7EC',
    negative_100: '#FDD3DD',
    negative_200: '#FBBBCA',
    negative_300: '#F891A9',
    negative_400: '#F65A7F',
    negative_500: '#E91646',
    negative_600: '#CA123D',
    negative_700: '#A71134',
    negative_800: '#7F0B26',
    negative_900: '#5F071C',
    negative_950: '#430413',
    negative_975: '#30030D',

    positive_25: '#F0FFF8',
    positive_50: '#DDFFF0',
    positive_100: '#ACFFDE',
    positive_200: '#1DF2BA',
    positive_300: '#11E8B2',
    positive_400: '#00CE9D',
    positive_500: '#00AB82',
    positive_600: '#008F6C',
    positive_700: '#006E53',
    positive_800: '#004F3A',
    positive_900: '#003123',
    positive_950: '#00160E',
    positive_975: '#000A06',

    like: '#EC4899',

    custom_accent: '#1DF2BA',
    custom_accent_hover: '#18cfa0',
    custom_accent_disabled: '#8fd9c5',
    custom_text: '#392f70',
    custom_border_contrast_low: '#272C4E',
    custom_border_contrast_high: '#341071',

    /*
contrast_0: '#FFFFFF',
contrast_25: '#F9F9F9',
contrast_50: '#F7F7F9',
contrast_100: '#EEEEF1',
contrast_200: '#DCDBE2',
contrast_300: '#D0CFD7',
contrast_400: '#B6B4C1',
contrast_500: '#9997A7',
contrast_600: '#7E7B8E',
contrast_700: '#615E71',
contrast_800: '#454351',
contrast_900: '#2B2932',
contrast_950: '#121116',
contrast_975: '#08080A',
contrast_1000: '#040405',
primary_25: '#F8FBFF',
primary_50: '#F0F6FF',
primary_100: '#E3EEFF',
primary_200: '#CBDCFF',
primary_300: '#B9CDFF',
primary_400: '#9CB2FF',
primary_500: '#7E91FF',
primary_600: '#696BFF',
primary_700: '#5E2EFF',
primary_800: '#4200B2',
primary_900: '#28004E',
primary_950: '#1A0031',
primary_975: '#0C0019',
positive_25: '#F0FFF8',
positive_50: '#DDFFF0',
positive_100: '#ACFFDE',
positive_200: '#1DF2BA',
positive_300: '#11E8B2',
positive_400: '#00CE9D',
positive_500: '#00AB82',
positive_600: '#008F6C',
positive_700: '#006E53',
positive_800: '#004F3A',
positive_900: '#003123',
positive_950: '#00160E',
positive_975: '#000A06',
negative_25: '#FFFAFA',
negative_50: '#FDF5F5',
negative_100: '#FBEAEA',
negative_200: '#F8D3D3',
negative_300: '#F6C4C3',
negative_400: '#F29F9F',
negative_500: '#ED3E3A',
negative_600: '#DB3834',
negative_700: '#B42D2A',
negative_800: '#831E1C',
negative_900: '#55100F',
negative_950: '#2A0404',
negative_975: '#140202',
*/
  },
  dark: {
    white: '#FFFFFF',
    black: '#000000',

    contrast_0: '#151D28',
    contrast_25: '#1C2736',
    contrast_50: '#222E3F',
    contrast_100: '#2C3A4E',
    contrast_200: '#394960',
    contrast_300: '#485B75',
    contrast_400: '#586C89',
    contrast_500: '#6F839F',
    contrast_600: '#8D9DB4',
    contrast_700: '#ABB8C9',
    contrast_800: '#C3CDDA',
    contrast_900: '#E2E7EE',
    contrast_950: '#F2F4F8',
    contrast_975: '#F9FAFB',
    contrast_1000: '#FFFFFF',

    primary_25: '#122136',
    primary_50: '#122949',
    primary_100: '#123464',
    primary_200: '#0E4490',
    primary_300: '#0A52B8',
    primary_400: '#0661E0',
    primary_500: '#0F73FF',
    primary_600: '#4D97FF',
    primary_700: '#80B5FF',
    primary_800: '#ADCFFF',
    primary_900: '#D6E7FF',
    primary_950: '#EBF3FF',
    primary_975: '#F5F9FF',

    negative_25: '#3E0915',
    negative_50: '#500B1C',
    negative_100: '#6F0B22',
    negative_200: '#910D2C',
    negative_300: '#BA1239',
    negative_400: '#D81341',
    negative_500: '#EB2452',
    negative_600: '#F76486',
    negative_700: '#F99AB0',
    negative_800: '#FCC0CE',
    negative_900: '#FDD8E1',
    negative_950: '#FEEBEF',
    negative_975: '#FFF5F7',

    positive_25: '#000A06',
    positive_50: '#00160E',
    positive_100: '#003123',
    positive_200: '#004F3A',
    positive_300: '#006E53',
    positive_400: '#008F6C',
    positive_500: '#00AB82',
    positive_600: '#00CE9D',
    positive_700: '#11E8B2',
    positive_800: '#1DF2BA',
    positive_900: '#ACFFDE',
    positive_950: '#DDFFF0',
    positive_975: '#F0FFF8',

    like: '#EC4899',

    custom_accent: '#1DF2BA',
    custom_accent_hover: '#18cfa0',
    custom_accent_disabled: '#8fd9c5',
    custom_text: '#392f70',

    custom_text_light: '#2C0078',

    custom_background_primary: '#161928',

    custom_border_contrast_low: '#272C4E',
    custom_border_contrast_high: '#341071',

    /*
contrast_0: '#161928',
contrast_25: '#1D2433',
contrast_50: '#272F43',
contrast_100: '#2B2932',
contrast_200: '#454351',
contrast_300: '#615E71',
contrast_400: '#7E7B8E',
contrast_500: '#9997A7',
contrast_600: '#B6B4C1',
contrast_700: '#D0CFD7',
contrast_800: '#DCDBE2',
contrast_900: '#EEEEF1',
contrast_950: '#F7F7F9',
contrast_975: '#F9F9F9',
contrast_1000: '#FFFFFF',
primary_25: '#0C0019',
primary_50: '#1A0031',
primary_100: '#28004E',
primary_200: '#4200B2',
primary_300: '#5E2EFF',
primary_400: '#696BFF',
primary_500: '#7E91FF',
primary_600: '#9CB2FF',
primary_700: '#B9CDFF',
primary_800: '#CBDCFF',
primary_900: '#E3EEFF',
primary_950: '#F0F6FF',
primary_975: '#F8FBFF',
positive_25: '#000A06',
positive_50: '#00160E',
positive_100: '#003123',
positive_200: '#004F3A',
positive_300: '#006E53',
positive_400: '#008F6C',
positive_500: '#00AB82',
positive_600: '#00CE9D',
positive_700: '#11E8B2',
positive_800: '#1DF2BA',
positive_900: '#ACFFDE',
positive_950: '#DDFFF0',
positive_975: '#F0FFF8',
negative_25: '#140202',
negative_50: '#2A0404',
negative_100: '#55100F',
negative_200: '#831E1C',
negative_300: '#B42D2A',
negative_400: '#DB3834',
negative_500: '#ED3E3A',
negative_600: '#F29F9F',
negative_700: '#F6C4C3',
negative_800: '#F8D3D3',
negative_900: '#FBEAEA',
negative_950: '#FDF5F5',
negative_975: '#FFFAFA',*/
  },
} as const
